import React, { Component } from 'react';
import { VideoContentProvider } from '../store/videoContentProvider';
import { VideoContext } from '../store/videoContext';
import Util from '../modules/utilPc/';
import ShareActionBox from '../modules/shareBottom/';
const PCVideoUtil = new Util();

class MyVideo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            renderFlash: true,
        };
        this.emptyFunc = () => {};
    }

    getStartTime() {
        const aTemp = window.location.href.split('#')[0].split('?');
        const aSearch = aTemp.length > 1 ? aTemp[1].split('&') : [];

        for (let i = 0, iLen = aSearch.length; i < iLen; i++) {
            const s = aSearch[i];

            if (s.indexOf('starttime') === 0) {
                const starttime = parseFloat(s.substr(10));

                return isNaN(starttime) ? '0' : `${starttime}`;
            }
        }

        return '0';
    }

    changeCurrentSrc = (srcIndex, sourceItem, dispatch) => {
        dispatch({
            type: 'changeSource',
            payload: {
                currentPlaySource: sourceItem,
                currentPlayIndex: srcIndex,
            },
            callback: () => {
                this.setState({
                    renderFlash: true,
                });
            },
        });
    };

    initPlayerHooks = context => {
        const {
            dispatch,
            videoJsOptions: { sources },
            currentPlayIndex,
        } = context;

        const hooks = {};

        hooks['changePlayIndex'] = index => {
            if (typeof index === 'number' && index < sources.length) {
                if (currentPlayIndex !== index) {
                    this.setState(
                        {
                            renderFlash: false,
                        },
                        () => {
                            this.changeCurrentSrc(index, sources[index] || {}, dispatch);
                        },
                    );
                }
            } else {
                console.error('参数错误');
            }
        };

        return hooks;
    };

    renderFlashPlayer = playerContext => {
        const { renderFlash } = this.state;

        const {
            currentPlaySource: videoinfo,
            playermsg,
            playermsg: { playerHooks, loop = 'false' },
        } = playerContext;

        try {
            if (playerHooks) {
                playerHooks(this.initPlayerHooks(playerContext));
            }
        } catch (err) {
            console.error('init player hooks err: ', err);
        }

        if (renderFlash) {
            const guid = videoinfo.guid || videoinfo.vid || '';
            const adTag = 'ifeng';
            const parent = 0;
            let fromvalue = 'free';
            const ADPlay = false;
            const uid = PCVideoUtil.playerGetCookie('userid');
            const sid = PCVideoUtil.playerGetCookie('sid');
            const locid = PCVideoUtil.playerGetCookie('location');
            const time = this.getStartTime();
            const pageurl = window.location.href;
            const autoplay = playermsg.autoPlay;
            const preAdType = 0;
            let adtype = '';
            let playerName = '';
            let swfUrl = '//vxml.ifengimg.com/swf/vFreePlayer_v7.0.0.swf';

            if (videoinfo) {
                adtype = videoinfo.adtype || '5';
                playerName = videoinfo.playerName || 'vFreePlayer';
                const categoryId = videoinfo.categoryId;

                if (categoryId) {
                    const categoryId_paths = categoryId.split('-');
                    const _categoryId = categoryId_paths[0];

                    if (_categoryId !== '154') {
                        adtype = '4';
                        fromvalue = 'vdocumentary';
                        playerName = 'vDocPlayer';
                        swfUrl = '//vxml.ifengimg.com/swf/vDOCPlayer_v7.0.1.swf';
                    }
                }
            }

            const flashHtml = `<object
                classID="clsid:d27cdb6e-ae6d-11cf-96b8-444553540000"
                width="100%"
                height="100%"
                codebase="//fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=6,0,0,0"
                id="js_playVideo">
                <param name="movie" value ="${swfUrl}" />
                <param name="allowFullScreen" value="true" />
                <param name="wmode" value="transparent" />
                <param name="play" value="${autoplay}" />
                <param name="flashvars" value="guid=${guid}&autoplay=${autoplay}&autostart=${autoplay}&play=${autoplay}&adTag=${adTag}&ADPlay=${ADPlay}&uid=${uid}&sid=${sid}&locid=${locid}&startTime=${time}&parent=${parent}&adType=${adtype}&from=${fromvalue}&PlayerName=${playerName}&preAdType=${preAdType}&pageurl=${pageurl}"/>
                <param name="allowscriptaccess" value="always" />
                <embed pluginspage="//www.macromedia.com/go/getflashplayer"
                    type="application/x-shockwave-flash"
                    src="${swfUrl}"
                    height="100%"
                    width="100%"
                    id="js_playVideo"
                    name="swf"
                    autoplay="${autoplay}"
                    autostart="${autoplay}"
                    play="${autoplay}"
                    loop="${loop}"
                    flashvars="guid=${guid}&autoplay=${autoplay}&autostart=${autoplay}&play=${autoplay}&adTag=${adTag}&ADPlay=${ADPlay}&uid=${uid}&sid=${sid}&locid=${locid}&startTime=${time}&parent=${parent}&adType=${adtype}&from=${fromvalue}&PlayerName=${playerName}&preAdType=${preAdType}&pageurl=${pageurl}"
                    allowFullScreen="true"
                    wmode="transparent"
                    allowscriptaccess="always"
                />
            </object>`;

            return (
                <div
                    // id="js_video"
                    style={{ width: `${playermsg.width}px`, height: `${playermsg.height}px` }}
                    dangerouslySetInnerHTML={{ __html: videoinfo ? flashHtml : null }}
                />
            );
        }

        return null;
    };

    render() {
        return (
            <VideoContentProvider initData={this.props}>
                <VideoContext.Consumer>
                    {context => {
                        const {
                            currentPlaySource,
                            videoJsOptions,
                            videoJsOptions: { shareItems, allowResize },
                            narrowWindowMode,
                        } = context;

                        return (
                            <div className="vPlayer_zone">
                                <div className="vPlayer_box videobox">{this.renderFlashPlayer(context)}</div>
                                {shareItems ? (
                                    <ShareActionBox
                                        currentPlaySource={currentPlaySource}
                                        config={videoJsOptions}
                                        narrowWindow={allowResize && narrowWindowMode}
                                    />
                                ) : null}
                            </div>
                        );
                    }}
                </VideoContext.Consumer>
            </VideoContentProvider>
        );
    }
}

export default MyVideo;
